import React from 'react';
import { Node } from 'prosemirror-model';

import { Popper } from '@lyearn/ui';

export type PopperProps = React.ComponentProps<typeof Popper>;

export enum WebBookmarkLayout {
  Small = 'small',
  Big = 'big',
}

export type NativeNodeViewProps = React.PropsWithChildren<{
  node: Node;
}>;
